export const environment = {
    production: true,
    apiUrl: "https://primehat.com",
    // The site's languages, English first, and its labels' app keys (Multilang_Culture_Spec.md 2.2, 5): every other
    // language is a URL prefix (/bn/...), and a page loads core's labels, then the site's own.
    cultureLanguages: ['en', 'bn'],
    cultureAppKeys: ['core', 'primehat'],
    // A language's own font (styles.scss), preloaded by its pages' server render: the regular weight, the body text's.
    cultureFonts: { bn: ['/assets/fonts/noto-sans-bengali/noto-sans-bengali-bengali-400-normal.woff2'] },
    // Bangla pages draw 0-9 as ০-৯ where styles.scss names this family - prices, totals, dates, quantities and counts
    // (shared/culture/bangla-digits.ts).
    banglaDigits: { family: 'PrimeHat Bangla Digits', files: '/assets/fonts/bangla-digits/PrimeHatBanglaDigits-{name}.otf' },
    // The brand, in one place for the whole app (shared/brand.ts reads it). The tagline is the home page's title (the
    // brand is appended) and index.html repeats it.
    brand: {
        name: 'PrimeHat',
        domain: 'primehat.com',
        tagline: 'Shop from Verified Sellers Across Bangladesh'
    },
    // Firebase project "prime-commerce-786", PrimeHat's own (Google sign-in). Public by design - see environment.ts.
    firebase: {
        apiKey: 'AIzaSyCPjvAEUWLf6SX4jgOb8XZk5eF3DgWGamE',
        authDomain: 'prime-commerce-786.firebaseapp.com',
        projectId: 'prime-commerce-786',
        storageBucket: 'prime-commerce-786.firebasestorage.app',
        messagingSenderId: '419274016075',
        appId: '1:419274016075:web:f966fd2f9b033ba21f14ce'
        },
    // PrimeHat's GA4 property, loaded by AnalyticsService (gtag.js). GoogleAnalytics:MeasurementId must be the same id.
    analytics: {
        measurementId: 'G-E5MPP2K87D',
        debugMode: false
    }
};
